
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));

// const app = new Vue({
//     el: '#app'
// });

import * as d3 from 'd3';
window.d3 = d3;

//import * as nv from 'nvd3'

require('jquery');
require('jquery-ui');
require( 'datatables.net-bs' );

import { createApp } from 'vue';
import { createPinia } from 'pinia';
window.pinia = createPinia();

import HelloVue from '../components/HelloVue.vue';

const helloVue = createApp({
    components: {
        HelloVue,
    }
});
helloVue.component('helloVue', helloVue);
$(document).ready( function(){
	if (document.getElementById("app")) {
	    helloVue.mount("#app");
	}
});

// import BarAndLine from '../components/bar_and_line.vue';

// const barandline = createApp({
//     components: {
//         BarAndLine,
//     }
// });
// barandline.component('barandline', barandline);
// $(document).ready( function(){
// 	if (document.getElementById("bar_and_line")) {
// 	    barandline.mount("#bar_and_line");
// 	}
// });
import BarAndLine from '../components/bar_and_line.vue';
const barandline = createApp({components: {
        BarAndLine,
    }}).use(window.pinia);
barandline.component('barandline',BarAndLine);
$(document).ready( function(){
	if (document.getElementById("bar_and_line")) {
	    barandline.mount("#bar_and_line");
	}
});

import FinancialIndicator from '../components/financial_indicator.vue';
const financialindicator = createApp({components: {
        FinancialIndicator,
    }}).use(window.pinia);
financialindicator.component('financialindicator',FinancialIndicator);
$(document).ready( function(){
	if (document.getElementById("financial_indicator")) {
	    financialindicator.mount("#financial_indicator");
	}
});

import Percentiles from '../components/percentiles.vue';
const percentiles = createApp({components: {
        Percentiles,
    }}).use(window.pinia);
percentiles.component('percentiles',Percentiles);
$(document).ready( function(){
	if (document.getElementById("percentiles")) {
	    percentiles.mount("#percentiles");
	}
});

